import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DateUtils } from '../../../../../utils/date-utils';
import { DatewiseEvents } from '../../../calendar/models/datewise-events';
import { SchoolEvent } from '../../../calendar/models/school-event';
import { WardsService } from 'src/app/services/wards-service/wards.service';
import { Student } from 'src/app/models/student';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PersonType } from 'src/app/models/person';
import { UserService } from 'src/app/services/user/user-service/user.service';

@Component({
  selector: 'app-daily-summary',
  templateUrl: './daily-summary.component.html',
  styleUrls: ['./daily-summary.component.scss']
})
export class DailySummaryComponent extends ComponentBase implements OnInit {

  todaysdate: string = new Date().toISOString().split('T')[0];
  oneDay: number = 24 * 60 * 60 * 1000;
  timetable: Array<SchoolEvent>;
  platform: string;
  @Input() selectedDay: DatewiseEvents;
  selectedProfile: Student;
  personType: PersonType;

  constructor(private wardsService: WardsService,
    private userService: UserService) { 
      super();
    }

  ngOnInit() {
    let sub1 = this.userService.getLoggedInUser()
      .subscribe(res => {
        this.personType = res.person.person_type;
    })
    this.addSubscription(sub1);

    let sub2 = this.wardsService.ward$
      .subscribe(ward => {
        this.selectedProfile = ward;
      });
    this.addSubscription(sub2);
  }

  ngOnChanges() {
    if (this.selectedDay) {
      this.timetable = [];
      this.selectedDay.homeworks_assigned = this.selectedDay.homeworks_assigned.filter(val => val.status != 2);
      this.selectedDay.homeworks_to_be_submitted = this.selectedDay.homeworks_to_be_submitted.filter(val => val.status != 2);
      this.selectedDay.time_table.forEach(tt => {
        this.selectedDay.homeworks_to_be_submitted.forEach(hw => {
          if (tt.title.includes(hw.subject_title)) {
            tt.hasHomeWork = true;
          }
        });
        this.timetable.push(tt);
      });
    }
  }

  isToday(date: string) {
    return this.todaysdate == date.split('T')[0];
  }

  findDifferenceInDays(date: string) {
    let firstDate = DateUtils.parseDateAndTime(date.split('T')[0]);
    let secondDate = DateUtils.parseDateAndTime(this.todaysdate);
    return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (this.oneDay)));
  }
}
